export default __webpack_public_path__ + "static/media/visa.f78c1cc7.svg";